import { useLocation, useNavigate } from "react-router-dom";
import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

const navLinks = [
  { path: "/",              label: "HOME",     icon: "🏠" },
  { path: "/about",         label: "ABOUT",    icon: "👤" },
  { path: "/skills",        label: "SKILLS",   icon: "🛠️" },
  { path: "/projects",      label: "PROJECTS", icon: "⚙️" },
  { path: "/certifications",label: "CERTS",    icon: "🎖️" },
  { path: "/contact",       label: "CONTACT",  icon: "📧" },
];

export default function Sidebar({ open, setOpen }) {
  const location = useLocation();
  const navigate = useNavigate();

  const goto = (path) => {
    navigate(path);
    setOpen(false);
  };

  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed", top: "1.1rem", left: open ? "235px" : "1.2rem", zIndex: 300,
          background: open ? C.accentDim : "rgba(13,17,23,0.85)",
          border: `1px solid ${open ? C.accentBorder : C.cardBorder}`,
          color: C.accent, width: "42px", height: "42px", borderRadius: "8px",
          fontSize: "1.2rem", cursor: "pointer", backdropFilter: "blur(12px)",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all 0.25s ease",
        }}
      >
        {open ? "✕" : "☰"}
      </button>

      {/* Overlay */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed", inset: 0, zIndex: 200,
            background: "rgba(0,0,0,0.55)", backdropFilter: "blur(3px)",
          }}
        />
      )}

      {/* Sidebar Panel */}
      <aside style={{
        position: "fixed", top: 0, left: 0, zIndex: 250,
        width: C.sidebar, height: "100vh",
        background: "rgba(10,13,22,0.97)",
        borderRight: `1px solid ${C.accentBorder}`,
        backdropFilter: "blur(20px)",
        display: "flex", flexDirection: "column",
        padding: "2rem 1.5rem",
        transform: open ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.35s cubic-bezier(0.4,0,0.2,1)",
        boxShadow: open ? `4px 0 40px rgba(0,212,255,0.08)` : "none",
      }}>
        {/* Logo */}
        <button className="nav-btn" onClick={() => goto("/")} style={{
          fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "1rem",
          color: C.accent, letterSpacing: "1px",
          marginBottom: "0.5rem", marginTop: "0.5rem", textAlign: "left",
        }}>
          DIRECTORY
        </button>

        <div style={{height: "1px", background: C.accentBorder, margin: "1.2rem 0 2rem", opacity: 0.5 }} />

        {/* Nav Links */}
        <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem", flex: 1 }}>
          {navLinks.map(({ path, label, icon }) => {
            const active = location.pathname === path;
            return (
              <button
                key={path}
                className="sidebar-link"
                onClick={() => goto(path)}
                style={{
                  background: active ? C.accentDim : "transparent",
                  border: `1px solid ${active ? C.accentBorder : "transparent"}`,
                  borderRadius: "6px", padding: "0.7rem 1rem",
                  color: active ? C.accent : C.muted,
                  fontFamily: FONT_MONO, fontSize: "0.8rem", letterSpacing: "2px",
                  textAlign: "left", display: "flex", alignItems: "center", gap: "0.8rem",
                  cursor: "pointer",
                }}
              >
                <span style={{ fontSize: "1rem" }}>{icon}</span>
                {label}
                {active && <span style={{ marginLeft: "auto", fontSize: "0.6rem", color: C.accent }}>●</span>}
              </button>
            );
          })}
        </div>

        {/* Bottom Info */}
        <div style={{ borderTop: `1px solid ${C.cardBorder}`, paddingTop: "1.2rem" }}>
          <div style={{ fontFamily: FONT_MONO, fontSize: "0.65rem", color: C.faint, letterSpacing: "1px" }}>
            {DATA.location}
          </div>
          <div style={{ fontFamily: FONT_MONO, fontSize: "0.65rem", color: C.faint, marginTop: "0.3rem" }}>
            {DATA.email}
          </div>
        </div>
      </aside>
    </>
  );
}
